export const environment = {
  production: false,
  apiKey: "AIzaSyDCw4d5IxdD8SKag46DouAV4CP9L5HrhR4",
  appId: "1:1043715203240:web:80c5b0d41e6a6fddb6629d",
  authDomain: "tswwrestling-9a710.firebaseapp.com",
  projectId: "tswwrestling-9a710",
  keyStripe: "pk_live_51HguLAJlaadW8A5lnIjW9WRZCWNMr8UasMXT8iNTWmBvUzwakgYaHCdO1duH47GtNbzPcYEkQefr4RU7z2DPUOYy00xHXPjByg",
}
